import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AUTH_QUERY_PARAMS } from '@pages/auth2/models/constants/auth.constant';
import { AUTH_FULL_ROUTES } from '@pages/auth2/models/constants/auth.routes.constants';
import { BtnModakComponent } from '@shared/components/dumb/button/button.component';
import { SECOND } from '@shared/models/constants/time.constant';
import { TOAST_SEVERITY_TYPES } from '@shared/primeng/constants/toast.constants';
import { AppFunctions } from '@shared/utils/app.functions';
import { ClipboardService } from 'ngx-clipboard';
import { MessageService } from 'primeng/api';
import { PROJECT_TAGS } from 'src/app/configs/libraries/tracking-manager/constants/projects.constants';
import { TrackingEvent } from 'src/app/configs/libraries/tracking-manager/interfaces/tracking-manager.interfaces';
import { TrackingManager } from 'src/app/configs/libraries/tracking-manager/tracking-manager';

@Component({
  selector: 'mdk-referral-copy-code',
  templateUrl: './referral-copy-code.component.html',
  styleUrls: [
    './styles/referral-copy-code.component.mobile.scss',
  ],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    BtnModakComponent
  ]
})
export class ReferralCopyCodeComponent {
  //#region [---- [INPUTS]  -----]
  @Input() public code: string
  @Input() public trackingEvent: TrackingEvent 
  //#endregion

  //#region [---- [DEPENDENCIES] ----]
  private readonly messageService: MessageService = inject(MessageService)
  private readonly clipboardService: ClipboardService = inject(ClipboardService)
  private readonly appFunctions: AppFunctions = inject(AppFunctions)
  private readonly translate: TranslateService = inject(TranslateService)
  private readonly trackingManager: TrackingManager = inject(TrackingManager)
  //#endregion

  //#region [---- [LOGIC] ----]
  public onClickCopy(): void {
    this.trackingManager.trackEventV2(
      this.trackingEvent,
      {
        project_tag: PROJECT_TAGS.REFERRALS,
        user: {
          referral: {
            code: this.code ?? ''
          } 
        }
      }
    )
    const message = this.buildCopyMessage()
    this.clipboardService.copyFromContent(message);
    this.messageService.add(
      {
        severity: TOAST_SEVERITY_TYPES.SUCCESS,
        summary: `${this.translate.instant('REFERRALS.CODE_COPIED')}`, 
        detail: '', 
        life: SECOND * 3
      });
  }

  public buildCopyMessage(): string {
    const initialMessage = `${this.translate.instant('REFERRALS.USE_MY_CODE')} ${this.code} ${this.translate.instant('REFERRALS.TO_JOIN')}`
    const hostName = this.appFunctions.getHostName()
    const relativePath = `${AUTH_FULL_ROUTES.SIGN_UP}?${AUTH_QUERY_PARAMS.REFERRAL_CODE}=${this.code}`
    const url = `${hostName}${relativePath}`
    return `${initialMessage} ${url}`
  }
  //#endregion
}
